import { Box } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Typography from '@ui/Typography';

const useStyles = makeStyles()(theme => ({
  errorCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
    padding: theme.spacing(5),
    gap: theme.spacing(0.5),
  },
  header: {
    fontSize: theme.spacing(1.5),
  },
}));

const NoWordEntered = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.errorCard}>
      <Typography
        variant="h5"
        bold
        className={classes.header}
      >{`No word entered`}</Typography>
      <Typography variant="pSm">{`Type a word in the "Original text" field in the sidebar to see suggestions.`}</Typography>
    </Box>
  );
};

export default NoWordEntered;
